export const ORGANISATION_DETAILS_REQUEST = "ORGANISATION_DETAILS_REQUEST";
export const ORGANISATION_DETAILS_RECEIVE = "ORGANISATION_DETAILS_RECEIVE";
export const ORGANISATION_DETAILS_FAILURE = "ORGANISATION_DETAILS_FAILURE";
export const RESET_ORGANISATION_DETAILS = "RESET_ORGANISATION_DETAILS";
